export const privacyConfig = {
    lastUpdated: "2024-11-28",
    title: "Privacy Policy",
    intro: "At LiveLoveSpain, your privacy matters to us. This Privacy Policy explains how we collect, use, and protect your information when you use our platform. By using our services, you agree to the practices described below. We’re here to help, so if you have any questions, feel free to reach out to us at support@livelovespain.com.",
    sections: [
      {
        title: "1. Information We Collect",
        subsections: [
          {
            title: "1.1 Personal Information",
            content:
              "We collect the information you provide when setting up your profile, such as your name, email address, and details about your personal relocation situation. This helps us deliver personalized recommendations and tasks tailored to your needs."
          },
          {
            title: "1.2 Usage Data",
            content:
              "We collect information about how you interact with the platform, such as the pages you visit and the features you use. This helps us improve your experience and ensure the platform is running smoothly."
          },
          {
            title: "1.3 Device Information",
            content:
              "To enhance security and compatibility, we collect basic device information like your IP address, browser type, and operating system. This helps us maintain a safe and reliable service for everyone."
          }
        ]
      },
      {
        title: "2. How We Use Your Information",
        subsections: [
          {
            title: "2.1 Personalized Services",
            content:
              "We use the information you provide in our wizard to create personalized task lists and relocation recommendations."
          },
          {
            title: "2.2 Communications",
            content:
              "We may contact you via email to provide updates, send reminders, and offer support. You can adjust your communication preferences in your account settings."
          },
          {
            title: "2.3 Legal Compliance and Security",
            content:
              "Your information may be used to comply with legal obligations, enforce our Terms of Service, or ensure platform security."
          }
        ]
      },
      {
        title: "3. Sharing Your Information",
        subsections: [
          {
            title: "3.1 Third-Party Services",
            content:
              "We use trusted third-party providers to manage services like payment processing. By using our platform, you consent to the sharing of necessary information with these providers. These providers follow strict data protection standards."
          },
          {
            title: "3.2 Legal Obligations",
            content:
              "If required by law, we may disclose your information to comply with legal processes or protect the rights and safety of others."
          },
          {
            title: "3.3 Business Changes",
            content:
              "In the event of a merger or acquisition, your data may be transferred to the new entity. We’ll notify you if this happens."
          }
        ]
      },
      {
        title: "4. Your Rights",
        subsections: [
          {
            title: "4.1 Access and Updates",
            content:
              "You can access and update your personal information anytime through your account settings."
          },
          {
            title: "4.2 Account Deletion",
            content:
              "If you wish to stop using the platform and delete your data, you can request account deletion through your settings. Please note that certain data may be retained for legal or operational purposes."
          },
          {
            title: "4.3 Withdrawal of Consent",
            content:
              "If you withdraw your consent to share data, we’ll deactivate your account as access to our services requires consent for data use."
          }
        ]
      },
      {
        title: "5. Security of Your Data",
        content:
          "We take security seriously and use modern encryption and security practices to protect your information. However, we also encourage you to keep your account secure by using strong passwords and monitoring for any unauthorized activity."
      },
      {
        title: "6. Children’s Privacy",
        content:
          "LiveLoveSpain is designed for users aged 18 and older. We do not knowingly collect information from minors. If you believe a minor has created an account, please contact us so we can take appropriate action."
      },
      {
        title: "7. Cookies and Tracking",
        content:
          "We use cookies and similar technologies to analyze site usage and improve our services. We use Google Analytics and Microsoft Clarity for website analytics, but only after obtaining your explicit consent through our cookie banner. These tools help us understand how users interact with our platform and improve your experience. You can change your cookie preferences at any time through your browser settings."
      },
      {
        title: "8. International Users",
        content:
          "If you’re accessing LiveLoveSpain from outside Spain, please note that your data will be processed and stored in Spain. By using the platform, you consent to this data transfer."
      },
      {
        title: "9. Updates and New Features",
        content:
          "We’re always working to improve our platform. When we release updates or new features, they’ll be included as part of your subscription at no additional cost."
      },
      {
        title: "10. Changes to This Policy",
        content:
          "We may update this Privacy Policy from time to time. Any changes will be posted here, and significant updates will be communicated via email or platform notifications."
      },
      {
        title: "11. Contact Us",
        content:
          "If you have any questions or concerns about this Privacy Policy, feel free to reach out to us at support@livelovespain.com."
      }
    ]
  };
  